import { Link } from 'react-router-dom';
import { Cluster } from '../ui/Layout';

export function PublicFooter(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <footer className="mx-auto mt-24 max-w-6xl px-4 pb-10 sm:px-6">
      <Cluster
        stackBelowSm
        gap={4}
        className="glass rounded-3xl border border-white/20 px-6 py-6 text-sm text-muted-foreground shadow-xl dark:border-white/10"
      >
        <p className="text-foreground">© {year} DefectSnap. Built for teams that improve how work gets done.</p>
        <Cluster gap={4}>
          <Link to="/security" className="transition hover:text-foreground">
            Security & privacy
          </Link>
          <Link to="/pricing" className="transition hover:text-foreground">
            Pricing
          </Link>
          <a
            href="mailto:raykundan57@gmail.com"
            target="_blank"
            rel="noreferrer"
            className="transition hover:text-foreground"
          >
            Contact
          </a>
        </Cluster>
      </Cluster>
    </footer>
  );
}
